module.exports = __webpack_public_path__ + "img/744.b505b3db.jpg";